import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import ConfirmDialog from '../components/ui/ConfirmDialog';

interface Confirmation { title: string; description: string; confirmLabel: string; danger?: boolean; cancelLabel?: string }
const ConfirmationContext = createContext<((options: Confirmation) => Promise<boolean>) | null>(null);

export function ConfirmationProvider({ children }: { children: React.ReactNode }) {
  const [options, setOptions] = useState<Confirmation | null>(null);
  const resolve = useRef<((value: boolean) => void) | null>(null);
  const finish = useCallback((value: boolean) => {
    const pending = resolve.current;
    resolve.current = null; setOptions(null); pending?.(value);
  }, []);
  const confirm = useCallback((next: Confirmation) => {
    // A second click must not replace the first pending action.
    if (resolve.current) return Promise.resolve(false);
    return new Promise<boolean>(done => { resolve.current = done; setOptions(next); });
  }, []);
  useEffect(() => () => { resolve.current?.(false); resolve.current = null; }, []);
  return <ConfirmationContext.Provider value={confirm}>
    {children}
    {options && <ConfirmDialog open {...options} onConfirm={() => finish(true)} onClose={() => finish(false)} />}
  </ConfirmationContext.Provider>;
}

export function useConfirmation() {
  const confirm = useContext(ConfirmationContext);
  if (!confirm) throw new Error('ConfirmationProvider fehlt.');
  return confirm;
}
